export const PREFIX = "@language/";

export const SELECTED_LANGUAGE = `${PREFIX}SELECTED_LANGUAGE`;